module.exports = __webpack_public_path__ + "img/hr-bill-nothing.88c207c4.png";